import React, { useState } from "react";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import NumberFormat from "react-number-format";
import {
  Crown,
  TrendingUp,
  Users,
  Gift,
  Utensils,
  ChevronLeft,
  ChevronRight,
  ArrowRight,
  CheckCircle2,
} from "lucide-react";

const Slide1 = ({ onBuyNow }) => (
  <div className="flex flex-col">
    <div className="flex justify-center mb-3">
      <div className="w-12 h-12 bg-green-50 rounded-2xl flex items-center justify-center rotate-3">
        <Crown className="w-6 h-6 text-green-600 -rotate-3" />
      </div>
    </div>

    <h2 className="font-gilroyBold text-3xl text-gray-900 text-center mb-4">
      HOW IT WORKS
    </h2>
    <div className="space-y-4">
      <div className="border-t border-orange-500 pt-3">
        <h3 className="font-gilroyBold text-gray-900 mb-1 text-xl">
          Restaurants:
        </h3>
        <p className="text-gray-700 font-gilroyMedium">
          Get up to <span className="font-gilroyBold">₦9,500 cash</span> discount on every order (discount is capped)
        </p>
      </div>

      <div className="border-t border-blue-500 pt-3">
        <h3 className="font-gilroyBold text-gray-900 mb-1 text-xl">
          Wholesale & Retail:
        </h3>
        <p className="text-gray-700 font-gilroyMedium">
          Get up to <span className="font-gilroyBold">₦17,500 cash</span> discount on every order (discount is capped)
        </p>
      </div>

      <div className="border-t border-green-500 pt-3">
        <h3 className="font-gilroyBold text-gray-900 mb-1 text-xl">
          Groups:
        </h3>
        <p className="text-gray-700 font-gilroyMedium">
          Gets <span className="font-gilroyBold">extra cash discounts</span> & can enjoy free delivery.
        </p>
      </div>

      <p className="border-t border-gray-200 pt-3 text-gray-700 font-gilroyMedium">
        <strong className="block font-gilroyBold text-gray-900">
          Refer. Earn. Repeat. 💰🚀
        </strong>
        Get rewarded every time someone joins Konnect through your referral.
      </p>
    </div>

    <button
      onClick={onBuyNow}
      className="mt-6 w-full bg-green-600 hover:bg-green-700 text-white px-6 py-3.5 rounded-xl font-gilroyBold transition-all flex items-center justify-center gap-2 uppercase tracking-wide shadow-md active:scale-95"
    >
      BUY NOW
      <ArrowRight className="w-5 h-5" />
    </button>
  </div>
);

const Slide2 = ({
  onNext,
  onPrev,
  displayCap,
  highDiscount = 70,
  baseDiscount = 20,
  t2BonusDiscount = 50,
  wkOrder3rdDiscountPercentage = 30,
  wkOrder3rdBonusCapped = 2500,
}) => (
  <div className="flex flex-col">
    <div className="flex justify-center mb-3">
      <div className="w-12 h-12 bg-blue-50 rounded-2xl flex items-center justify-center -rotate-3">
        <TrendingUp className="w-6 h-6 text-blue-600 rotate-3" />
      </div>
    </div>

    <h2 className="font-gilroyBold text-3xl text-gray-900 text-center mb-2">
      WEEKLY DISCOUNTS
    </h2>
    <p className="text-center mb-3 font-gilroyBold text-gray-900 ">
      Sunday — Saturday
    </p>

    <div className="space-y-1">
      <div className="p-2 rounded-lg bg-white border-2 border-dashed border-gray-100">
        <div className="flex items-center gap-2 mb-1">
          <div className="w-7 h-7 rounded-lg bg-green-100 flex items-center justify-center font-gilroyBold text-green-700 text-sm">
            01
          </div>
          <h4 className="font-gilroyBold ">First Order</h4>
        </div>
        <p className="leading-relaxed pl-9 ">
          Enjoy{" "}
          <span className="text-green-600 font-gilroyBold">
            {baseDiscount}%
          </span>{" "}
          <strong> AUTOMATIC</strong> discount
        </p>
      </div>

      <div className="p-2 rounded-lg bg-white border border-gray-100">
        <div className="flex items-center gap-2 mb-1">
          <div className="w-7 h-7 rounded-lg bg-blue-100 flex items-center justify-center font-gilroyBold text-blue-700 text-sm">
            02
          </div>
          <h4 className="font-gilroyBold ">Second Order</h4>
        </div>
        <p className="leading-relaxed pl-9 ">
          Discounts are powered by your{" "}
          <span className="text-green-600 font-gilroyBold">4Ward Balance</span>.
          Higher balance = Bigger savings.
        </p>
      </div>

      <div className="p-2 rounded-lg bg-orange-50 border border-orange-100">
        <div className="flex items-center gap-2 mb-1">
          <div className="w-7 h-7 rounded-lg bg-orange-500 flex items-center justify-center font-gilroyBold text-white text-sm">
            03
          </div>
          <h4 className="font-gilroyBold text-orange-900 ">The Third Order</h4>
        </div>
        <p className="text-orange-800/70 leading-relaxed pl-9 ">
          Enjoy an automatic{" "}
          <span className="font-gilroyBold text-orange-600">
            {wkOrder3rdDiscountPercentage}% discount
          </span>
          . No bonus balance required!
        </p>
      </div>
    </div>

    <div className="flex gap-2.5 mt-3">
      <button
        onClick={onPrev}
        className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center active:scale-90 transition-all"
      >
        <ChevronLeft className="w-8 h-8 " />
      </button>
      <button
        onClick={onNext}
        className="flex-grow bg-gray-900 text-white px-6 py-3 rounded-lg font-gilroyBold transition-colors flex items-center justify-center gap-2"
      >
        Next Step
        <ChevronRight className="w-5 h-5" />
      </button>
    </div>
  </div>
);

const Slide3 = ({ onPrev, footer, isTier2, navigate }) => (
  <div className="flex flex-col">
    <div className="flex justify-center mb-3">
      <div className="w-12 h-12 bg-purple-50 rounded-2xl flex items-center justify-center rotate-6">
        <Gift className="w-6 h-6 text-purple-600 -rotate-6" />
      </div>
    </div>

    <h2 className="font-gilroyBold text-3xl text-gray-900 text-center mb-2">
      BOOST YOUR BALANCE
    </h2>
    <p className="text-center mb-3 font-gilroyBold text-gray-900 ">
      Earn more, save more
    </p>

    <div className="space-y-1">
      <div className="flex items-center gap-2 p-2 rounded-lg bg-gray-50 border border-gray-100">
        <div className="w-6 h-6 rounded-lg bg-white flex items-center justify-center shadow-sm">
          <Users className="w-4 h-4 text-blue-500" />
        </div>
        <div>
          <h4 className="font-gilroyBold ">Tier 2 Referral</h4>
          <p className="">Invite friends to Tier 2 & earn.</p>
        </div>
      </div>
      <div className="flex items-center gap-2 p-2 rounded-lg bg-gray-50 border border-gray-100">
        <div className="w-6 h-6 rounded-lg bg-white flex items-center justify-center shadow-sm">
          <TrendingUp className="w-4 h-4 text-green-500" />
        </div>
        <div>
          <h4 className="font-gilroyBold ">Weekly Income</h4>
          <p className="">Earn when your friends order.</p>
        </div>
      </div>
      <div className="flex items-center gap-2 p-2 rounded-lg bg-gray-50 border border-gray-100">
        <div className="w-6 h-6 rounded-lg bg-white flex items-center justify-center shadow-sm">
          <Utensils className="w-4 h-4 text-orange-500" />
        </div>
        <div>
          <h4 className="font-gilroyBold ">Top Eater Bonus</h4>
          <p className="">Order often for weekly cashback.</p>
        </div>
      </div>
    </div>

    <div className="flex gap-2.5 mt-3">
      <button
        onClick={onPrev}
        className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center active:scale-90 transition-all"
      >
        <ChevronLeft className="w-8 h-8 " />
      </button>
      {footer ? (
        <div className="flex-grow">{footer}</div>
      ) : (
        <button
          onClick={() => {
            navigate("/marketplace");
          }}
          className="flex-grow bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-gilroyBold transition-colors flex items-center justify-center gap-2 uppercase"
        >
          <CheckCircle2 className="w-5 h-5" />
          ORDER NOW
        </button>
      )}
    </div>
  </div>
);

const DiscountComparisonContent = ({
  open,
  onClose,
  footer,
  promoCap,
  rateConfig,
  isTier2,
  navigate: propNavigate,
  highDiscount = 70,
  baseDiscount = 20,
}) => {
  const routerNavigate = useNavigate();
  const navigate = propNavigate || routerNavigate;
  const [currentSlide, setCurrentSlide] = useState(1);
  const displayCap = rateConfig?.promoCap || promoCap || 2000;
  const weekStartBonusCap = rateConfig?.weekStartBonusCapped || 2000;
  const t1WeekStartBonusCap = rateConfig?.t1WeekStartBonusCapped || 500;
  const t2WeekStartBonusCap = rateConfig?.t2WeekStartBonusCapped || 25000;
  const tier2Bonus = rateConfig?.tier2Cap || 2000;
  const configHighDiscount =
    rateConfig?.weekStartDiscountPercentageSlot || highDiscount;
  const configBaseDiscount =
    rateConfig?.bonusDiscountWithoutBalanceSD ??
    rateConfig?.weekStartDiscountPercentageWithoutSlot ??
    baseDiscount;
  const t2BonusDiscount = rateConfig?.t2BonusDiscountWithBalance || 50;
  const wkOrder3rdDiscountPercentage =
    rateConfig?.wkOrder3rdDiscountPercentage || 60;
  const wkOrder3rdBonusCapped = rateConfig?.wkOrder3rdBonusCapped || 2500;

  const handleClose = () => {
    setCurrentSlide(1);
    onClose?.();
  };

  const handleBuyNow = () => {
    handleClose();
    navigate("/restaurant");
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      closable={false}
      centered
      styles={{ body: { padding: "" } }}
    >
      <div className="flex justify-center mb-3">
        <div className="h-1 rounded-full bg-green-600 w-8" />
      </div>

      {currentSlide === 1 && <Slide1 onBuyNow={handleBuyNow} />}
    </Modal>
  );
};

export default DiscountComparisonContent;
